module.exports = __webpack_public_path__ + "static/media/getStarted.84607727.svg";